const apiSettings = {
  path: "/admin/api-settings",
  name: "ApiSettings",
  component: () =>
    import(
      /* webpackChunkName: "api-settings" */ "@/components/settings/ApiSettings.vue"
    ),
  meta: { authorize: ["Administrator", "Manager"], requiresAuth: true },
};

export default apiSettings;
